// Utility function to get logo URL based on theme
// Logos are stored in Cloudinary and fetched dynamically based on light/dark mode

export const getLogoUrl = () => {
  // Check current theme
  const theme = document.documentElement.getAttribute('data-theme') || 'light';
  
  // Cloudinary URLs for logos - All logos fetched from Cloudinary
  const logos = {
    light: 'https://res.cloudinary.com/dmmetrvda/image/upload/v1766323091/weheal/We-light.png',
    dark: 'https://res.cloudinary.com/dmmetrvda/image/upload/v1766217550/weheal/logo.png'
  };
  
  return theme === 'dark' ? logos.dark : logos.light;
};

// Export individual logo URLs for direct access if needed
export const LOGO_URLS = {
  light: 'https://res.cloudinary.com/dmmetrvda/image/upload/v1766323091/weheal/We-light.png',
  dark: 'https://res.cloudinary.com/dmmetrvda/image/upload/v1766217550/weheal/logo.png'
};

